/* import __COLOCATED_TEMPLATE__ from './-option.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { modifier } from 'ember-modifier';
let Option = (_class = class Option extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "guid", guidFor(this));
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "id", `headlessui-radiogroup-option-${this.guid}`);
    _defineProperty(this, "label", `headlessui-label-${this.guid}`);
    _defineProperty(this, "value", this.args.value);
    _defineProperty(this, "registration", modifier(element => {
      this.element = element;
      this.args.registerOption(this);
      return () => {
        this.element = null;
        this.args.unregisterOption(this);
      };
    }));
    let {
      radioGroupGuid
    } = this.args;
    if (radioGroupGuid === undefined) {
      throw new Error('<RadioGroup::-Option /> is missing a parent <RadioGroup /> component.');
    }
  }
  onClick(value) {
    if (this.args.disabled) return;
    let hasOptionNotBeenSelected = this.args.selectedValue !== value;
    if (this.args.onChange && hasOptionNotBeenSelected) {
      this.args.onChange(value);
    }
    this.args.handleClick(value);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class);
export { Option as default };